const RECEIVE_ADPLATFORM_SETTINGS_BY_CLIENT =
  'src/adPlatformSettingsByClient/RECEIVE_ADPLATFORM_SETTINGS_BY_CLIENT' as const;
const CLEAR_ADPLATFORM_SETTINGS_BY_CLIENT =
  'src/adPlatformSettingsByClient/CLEAR_ADPLATFORM_SETTINGS_BY_CLIENT' as const;

export default {
  CLEAR_ADPLATFORM_SETTINGS_BY_CLIENT,
  RECEIVE_ADPLATFORM_SETTINGS_BY_CLIENT
};
